<template>

  <div
    class="modal"
    tabindex="-1"
    role="dialog"
    v-if="showTerms && permissions.includes('manage_settings')">
    <div
      class="modal-dialog"
      role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t('Terms and conditions') }}</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click="show=false">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p v-html="$t('text_terms', { terms_link: 'https://www.quickin.io/termos-e-condicoes/', privacy_link: 'https://www.quickin.io/politica-de-privacidade/' })"></p>
        </div>
        <div class="modal-footer">
          <button
            :class="{'box-loading': loading}"
            type="button"
            class="btn btn-primary"
            @click="AcceptTerms">{{ $t('I accept the terms and conditions') }}</button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'AcceptTerms',
  components: {
  },
  data () {
    return {
      loading: false,
      show: true
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    },
    account () {
      return this.$store.getters.getAccount
    },
    showTerms () {
      return !this.account.accepted_terms && this.show
    }
  },
  created () {
  },
  methods: {
    AcceptTerms () {
      this.loading = true

      this.$store
      .dispatch('updateCurrentAccount', {
        accepted_terms: true
      })
      .then(result => {
        this.loading = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modal{
  display: block;
  background: rgb(0,0,0,0.7);
  padding: 20px;
}
/* .modal-dialog {
  margin: 0 auto; 
  height: 100%;
}
.modal-content {
  height: 100%;
}
.modal-body {
  overflow: auto;
  max-height: 100%;
} */
</style>



// WEBPACK FOOTER //
// src/components/AcceptTerms/AcceptTerms.vue